module.exports = __webpack_public_path__ + "img/IMG_20191130_011434.fdd59b52.jpg";